const themeConfig = {
    colors: {
        default: {
            primary: '#4C58A2',
            tertiary: '#4C58A2',
        },
        hover: {
            primary: '#5560a7',
            tertiary: '#5560a7',
        },
    },
};

export default themeConfig;
